const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Parse a `?date=` deep-link param into a Date.
 *
 * Date-only values (YYYY-MM-DD) must be constructed in local time:
 * `new Date('2026-08-24')` parses as UTC midnight, which is the previous
 * evening in every negative-UTC-offset timezone, so the calendar would land
 * on the wrong day. Noon (rather than local midnight) keeps the day stable
 * even across DST transitions where midnight may not exist.
 *
 * Full datetime values parse with normal `new Date()` semantics. Returns
 * null for unparseable input (including rollover dates like 2026-02-31).
 */
export const parseDateParam = (value: string): Date | null => {
  if (DATE_ONLY_PATTERN.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(year, month - 1, day, 12);
    const isRollover =
      date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day;
    return isRollover ? null : date;
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};
